// useBankAccounts — TanStack Query hook for the current merchant's bank rails.
//
// Mirrors the useMe() pattern: selects status from useAuth and currentMerchantId
// from useUI; guards the query on both. queryKey is per-merchant so the cache is
// scoped correctly when the user switches merchants.
import { useQuery } from "@tanstack/react-query";

import { listBankAccounts } from "@/api/bankAccounts";
import { useAuth } from "@/store/auth";
import { useUI } from "@/store/ui";

export function useBankAccounts() {
  const status = useAuth((s) => s.status);
  const currentMerchantId = useUI((s) => s.currentMerchantId);

  return useQuery({
    queryKey: ["bank-accounts", currentMerchantId],
    queryFn: () => listBankAccounts(currentMerchantId!),
    enabled: status === "authenticated" && currentMerchantId != null,
    staleTime: 30_000,
  });
}
